import type { DeviceQueue } from "../types";

export function queueResumeState(device: DeviceQueue | null): {allowed: boolean; reason: string} {
  const open = device?.queue.filter(entry => !['completed', 'cancelled', 'terminated', 'failed', 'dead_letter'].includes(entry.task.status)) ?? [];
  if (!device || !open.length) return {allowed: false, reason: '暂无可继续的任务'};
  if (device.status !== 'online') return {allowed: false, reason: '手机当前不在线或由人工控制'};
  if (open.some(entry => entry.task.status === 'stopping')) return {allowed: false, reason: '手机正在停止，等待确认释放'};
  if (open.some(entry => entry.state === 'blocked' || entry.blocked_by_incident_id || ['waiting_human', 'waiting_codex', 'running'].includes(entry.task.status))) return {allowed: false, reason: '当前任务正在运行或等待处理'};
  if (!device.queue_paused && !open.some(entry => entry.task.status === 'paused')) return {allowed: false, reason: '队列正常运行，无需继续'};
  // Continuing a paused queue does not authorize early execution. The server
  // retains each schedule and decides when it can be claimed; PC time cannot.
  return {allowed: true, reason: '继续此手机可恢复的任务'};
}
